// extracted by mini-css-extract-plugin
export default {"container":"IngredientsSection-module__container__tj6gy","title":"IngredientsSection-module__title__KTwVP","text":"IngredientsSection-module__text__nsORy"};